import Vue from 'vue';
import {
  SET_ALL,
  ADD_ANALYTICS_MESSAGES,
  SET_MESSAGE_AS_READ,
} from './mutation-types';

export default {
  [SET_ALL](state, data) {
    Object.assign(state, data);
    return state;
  },
  [ADD_ANALYTICS_MESSAGES](state, messages) {
    state.analyticsMessagesData = state.analyticsMessagesData.concat(messages);
    return state.analyticsMessagesData;
  },
  [SET_MESSAGE_AS_READ](state, messageId) {
    const message = state.analyticsMessagesData.find(m => m.id === messageId);
    if (message) {
      Vue.set(message, 'read_flag', true);
    }
  },
};
